export const manualInvoiceModal = {
  modalTitle: {
    create: "إنشاء فاتورة يدويًا",
    correcting: "تصحيح بيانات الفاتورة",
  },
  confirm: {
    title: "راجع قبل الإنشاء",
    subtitle: "ستُنشأ مسودة. يمكنك مراجعتها وإضافة رسوم وإصدارها متى شئت.",
    rowDocument: "المستند",
    documentValue: "مسودة · الرقم عند الإصدار",
    rowType: "النوع",
    typeCompany: "شركة / كيان اعتباري",
    typeIndividual: "فرد",
    labelCompanyName: "الاسم القانوني",
    labelName: "الاسم",
    rowCountry: "الدولة",
    rowEmail: "البريد الإلكتروني",
    rowAddress: "العنوان",
    rowPayment: "الدفع",
    rowNotes: "ملاحظات",
  },
  info: {
    createTitle: "ستُنشأ مسودة فاتورة (بدون رقم حتى الإصدار).",
    correctingTitle: "تصحيح البيانات الضريبية",
    createBody:
      "ستُحفظ كمسودة. يمكنك إضافة الرسوم، وعند جاهزيتها، إصدارها — الرقم التسلسلي تحدده الجهة الضريبية عند الإصدار.",
    correctingBody:
      "عدّل فقط البيانات التي تحتاج إلى تصحيحها. ستُنشأ <strong>فاتورة تصحيحية</strong> بالبيانات الصحيحة.",
  },
  prefillLoading: "جارٍ تحميل البيانات الضريبية للنزيل…",
  // Facturar toda la reserva o una sola habitación (reservas de varias).
  scope: {
    lead: "هذا الحجز يشمل عدة غرف. أي فاتورة تريد إنشاءها؟",
    continue: "متابعة",
    label: "كيف تريد إصدار الفاتورة؟",
    whole: "الحجز بالكامل",
    wholeHint: "فاتورة واحدة تشمل {n} غرف.",
    perRoom: "غرفة واحدة",
    perRoomHint: "لكل غرفة فاتورتها: لياليها ورسومها.",
    pickRoom: "اختر الغرفة",
    repeatHint: "كرّر ذلك مع كل غرفة ليحصل كل نزيل على فاتورته.",
  },

  recipientType: {
    label: "نوع المستلم",
    individual: "فرد",
    individualSub: "شخص طبيعي",
    company: "شركة",
    companySub: "شخص اعتباري",
    active: "نشط",
  },
  // Buscador de clientes del fichero dentro del modal: evita teclear a mano
  // una empresa que ya está guardada.
  client: {
    label: "عميل محفوظ",
    help: "ابحث عن عميل من سجل العملاء وستُملأ بياناته الضريبية تلقائيًا. وإن لم يكن موجودًا، اكتب البيانات يدويًا.",
    clear: "إزالة",
    linkedHint: "بيانات مأخوذة من ملف العميل. يمكنك تصحيح أي حقل دون فقدان الارتباط بالعميل.",
    noFiscalProfile: "هذا العميل ليس له ملف فوترة محفوظ: جلبنا الاسم والبريد الإلكتروني، وبقية البيانات يجب كتابتها (أو أكمل ملفه في العملاء).",
  },
  fields: {
    nameCompany: "الاسم القانوني *",
    nameIndividual: "الاسم الكامل *",
    country: "الدولة",
    countryPlaceholder: "اختر دولة النزيل",
    countryHint: "أدخل الدولة الضريبية للنزيل من أجل الفاتورة.",
    optional: "(اختياري)",
    emailLabel: "البريد الإلكتروني للفوترة",
    phoneLabel: "الهاتف",
    addressLabel: "العنوان الضريبي",
    sectionInvoiceData: "بيانات الفاتورة",
    paymentSourceLabel: "مصدر الدفع",
    paymentHintPrefilled:
      "محدد بناءً على المدفوعات التي سجّلتها. غيّره إن لم يكن صحيحًا.",
    paymentHintMulti: "يمكنك تحديد أكثر من خيار إذا دُفعت الإقامة بأكثر من طريقة.",
    paymentHintNone: "إذا لم تحدد شيئًا، لن تذكر الفاتورة طريقة الدفع.",
    seriesLabel: "السلسلة",
    seriesHint: "تأتي هذه السلسلة من إعدادات الفوترة.",
    notesLabel: "تفاصيل إضافية للفاتورة",
    notesHint: "استخدمه لإضافة وصف حر أو توضيحات أو تفاصيل إضافية للإصدار.",
  },
  preview: {
    label: "الرقم التسلسلي التالي",
    estHint: "للعلم · يُحدد عند الإصدار (أول من يُصدر يحصل عليه)",
    noNumber: "يُحدد عند الإصدار · المسودة بدون رقم",
  },
  footer: {
    cancel: "إلغاء",
    create: "إنشاء فاتورة",
    editData: "تعديل البيانات",
    creating: "جارٍ الإنشاء...",
    createDraft: "إنشاء مسودة",
  },
  success: {
    title: "تم إصدار الفاتورة!",
    badge: "صادرة",
    pdfGenerating: "يجري إنشاء ملف PDF. قد يستغرق بضع ثوانٍ.",
    downloadPdf: "تنزيل فاتورة PDF",
    generatingPdf: "جارٍ إنشاء PDF…",
    sendWhatsapp: "إرسال عبر واتساب",
    closeWindow: "إغلاق النافذة",
  },
  paymentSource: {
    cash: "نقدًا",
    card: "بطاقة ائتمان",
    transfer: "تحويل بنكي",
    otherOta: "مدفوعة عبر وكالة سفر أخرى (OTA)",
  },
  prefill: {
    clientFile:
      "بيانات مأخوذة من ملف العميل. راجعها قبل إنشاء المسودة.",
    invoiceRecipient: "بيانات محمّلة مسبقًا من آخر فاتورة للنزيل.",
    chat: "بيانات ضريبية قدّمها النزيل عند طلب فاتورته. راجعها ثم أصدر.",
    checkin:
      "حمّلنا مسبقًا اسم النزيل وبريده الإلكتروني من تسجيل وصوله. أكمل بياناته الضريبية أدناه.",
    reservation:
      "لم تكن هناك بيانات ضريبية كاملة؛ تُستخدم البيانات الأساسية للحجز كأساس.",
    existingInvoice:
      "بيانات محمّلة مسبقًا من الفاتورة الحالية. عدّل ما تحتاج إلى تصحيحه.",
  },
  status: {
    sent: "صادرة",
    processing: "قيد المعالجة",
    pending: "معلّقة",
    error: "خطأ",
  },
  toast: {
    whatsappSent: "تم إرسال الفاتورة عبر واتساب.",
    whatsappError: "تعذّر إرسال الفاتورة عبر واتساب.",
    draftCreated: "تم إنشاء المسودة. راجعها وأصدرها عندما تكون جاهزة.",
  },
  validation: {
    nameRequired: "الاسم أو الاسم القانوني مطلوب.",
    countryInvalid: "اختر دولة صالحة.",
    emailInvalid: "أدخل بريدًا إلكترونيًا صالحًا.",
    taxIdRequired: "هذا الرقم الضريبي مطلوب لهذا النوع من المستلمين.",
  },
  errors: {
    conflict: "الحجز لديه فاتورة مُنشأة بالفعل.",
    checkData: "راجع بيانات الفوترة.",
    createFailed: "تعذّر إنشاء الفاتورة.",
  },
  taxId: {
    labels: {
      esCompany: "الرقم الضريبي للشركة (NIF)",
      brIndividual: "CPF أو RG",
      defaultIndividual: "رقم التعريف الضريبي",
      defaultCompany: "الرقم الضريبي",
    },
    hints: {
      esIndividual: "DNI أو NIE (X1234567A). جواز السفر ليس رقمًا ضريبيًا صالحًا.",
      esCompany: "رقم NIF/CIF للشركة.",
      ptIndividual: "9 أرقام.",
      ptCompany: "9 أرقام.",
      coIndividual: "من 6 إلى 10 أرقام.",
      coCompany: "NIT مع رقم التحقق.",
      mxIndividual: "RFC لشخص طبيعي.",
      mxCompany: "RFC لشخص اعتباري.",
      arIndividual: "11 رقمًا مع رقم التحقق.",
      arCompany: "11 رقمًا مع رقم التحقق.",
      clIndividual: "مع رقم التحقق.",
      clCompany: "مع رقم التحقق.",
      peIndividual: "8 أرقام.",
      peCompany: "11 رقمًا.",
      ecIndividual: "10 أرقام.",
      ecCompany: "13 رقمًا.",
      brIndividual:
        "CPF صالح للفوترة الضريبية. إذا أدخلت RG، فسيُحفظ كوثيقة محلية للنزيل.",
      brCompany: "14 رقمًا.",
      defaultIndividual: "اختياري.",
      defaultCompany: "إلزامي للشركات.",
    },
  },
  address: {
    ES: { city: "المدينة", state: "المقاطعة", zip: "الرمز البريدي" },
    PT: { city: "المدينة", state: "المنطقة", zip: "الرمز البريدي" },
    CO: { city: "المدينة", state: "المحافظة", zip: "الرمز البريدي" },
    MX: { city: "المدينة", state: "الولاية", zip: "الرمز البريدي" },
    AR: { city: "المدينة", state: "المقاطعة", zip: "الرمز البريدي" },
    CL: { city: "المدينة", state: "المنطقة", zip: "الرمز البريدي" },
    BR: { city: "المدينة", state: "الولاية", zip: "الرمز البريدي" },
    US: { city: "المدينة", state: "الولاية", zip: "الرمز البريدي" },
    GB: { city: "المدينة", state: "المقاطعة", zip: "الرمز البريدي" },
    DEFAULT: { city: "المدينة", state: "المنطقة", zip: "الرمز البريدي" },
  },
  taxErrors: {
    cifCompany: "رقم NIF/CIF للشركة غير صالح.",
    esIndividual: "مستند غير صالح. أدخل DNI أو NIE (X1234567A) أو جواز سفر.",
    ptNif: "رقم NIF غير صالح. يجب أن يتكون من 9 أرقام صالحة.",
    nit: "رقم NIT غير صالح.",
    coCedula: "رقم Cédula غير صالح. بين 6 و10 أرقام.",
    rfc: "رقم RFC غير صالح.",
    cuit: "رقم CUIT غير صالح.",
    cuilCuit: "رقم CUIL/CUIT غير صالح.",
    rut: "رقم RUT غير صالح.",
    ruc: "رقم RUC غير صالح.",
    peDni: "رقم DNI غير صالح. يجب أن يتكون من 8 أرقام.",
    ecCedula: "رقم Cédula غير صالح.",
    cnpj: "رقم CNPJ غير صالح.",
    brIndividual: "مستند غير صالح. استخدم CPF صالحًا أو RG بالصيغة المعتادة.",
  },
};
